@let isToggleAutoRenewEnabledFlag = (isToggleAutoRenewEnabledFlag$ | async)!;
@let isAddressAutoCompleteEnabledFlag = (isAddressAutoCompleteEnabledFlag$ | async)!;
@let isPaymentValidationDisableFlag = (isPaymentValidationDisableFlag$ | async)!;
@let isEaglesMvpCardEnabledFlag = (isEaglesMvpCardEnabledFlag$ | async)!;
@let isJoinPromoCodeDisabledFlag = (isJoinPromoCodeDisabledFlag$ | async)!;

@let hideApplyPromo = (hideApplyPromo$ | async)!;
@let showMonthlyPayment = (showMonthlyPayment$ | async)!;
@let formValues = (formValues$ | async)!;
@let totalCost = (totalCost$ | async)!;
@let isMonthlyBilling = (isMonthlyBilling$ | async)!;
@let allowZeroPrice = (allowZeroPrice$ | async)!;
@let formActiveStep = (formActiveStep$ | async)!;
@let showMedicalPlanGiftInfo = (showMedicalPlanGiftInfo$ | async)!;
@let associateMedicalPrice = (associateMedicalPrice$ | async)!;

@let allStates = (allStates$ | async)!;
@let memberStates = (memberStates$ | async)!;

@let payment = (payment$ | async)!;
@let isLoadingRecostValidation = (isLoadingRecostValidation$ | async)!;
@let isLoadingPaymentForm = (isLoadingPaymentForm$ | async)!;
@let isPaymentGenerating = (isPaymentGenerating$ | async)!;
@let page = (page$ | async)!;
@let selectedLevel = (selectedLevel$ | async)!;
@let executionData = (executionData$ | async)!;
@let isDisabledChangeAutoRenew = (isDisabledChangeAutoRenew$ | async)!;
@let isNapamapProgramCode = (isNapamapProgramCode$ | async)!;
@let queryAutoRenew = (queryAutoRenew$ | async)!;
@let isLoadingExecution = (isLoadingExecution$ | async)!;
<!-- Northway: no auto renew flip or promo apply while a quote, the token or the payment is in flight, so
     nothing recosts (and opens an AXIS calc session) under them. Northway only: disableAutoRenew going
     false re-enables the control, which would undo the monthly-payment and confirmation disables other
     clubs use (functions campana/AUTO-RENEW-REVIEW.md F9, W7) -->
@let northwayBusy =
  clubId() === ClubApp.Northway && (isLoadingRecostValidation || isPaymentGenerating || isLoadingExecution);
@let hideAddAssociate = (hideAddAssociate$ | async)!;
@let offers = (offers$ | async)!;
@let showMedicalPlanCurrentClub = (showMedicalPlanCurrentClub$ | async)!;

<div class="tw-mx-auto tw-flex tw-w-full tw-max-w-[1000px] tw-gap-4">
  <form
    avaConnectForm
    [formGroup]="joinFormVm.formGroup"
    [formValues]="formValues"
    (formValuesChanged)="formGroupValuesChanged($event)"
    class="tw-flex tw-w-full tw-flex-col tw-gap-1"
    id="join-form"
  >
    <ava-alert [message]="errorMessage$ | async" type="warning" />

    @if (isValidProgramCode$ | async) {
      @let couponDescription = (couponDescription$ | async)!;
      @let couponAlertType = (couponAlertType$ | async)!;
      @let couponMessage = (couponMessage$ | async)!;

      <ava-alert
        [timeout]="20000000"
        [message]="couponMessage"
        [description]="couponDescription"
        [type]="couponAlertType"
      />
    }

    <ava-accordion
      [activePanelId]="formActiveStep"
      (selectPanel)="joinFormVm.formGroup.enabled && selectedPanel($event, formActiveStep)"
    >
      @if (showGiftRecipient$ | async) {
        @let showGiftMessage = (showGiftMessage$ | async)!;

        <ava-expansion-panel panelId="giftReceiverInfo">
          <ava-expansion-panel-header>
            <span class="tw-font-mission">Gift Recipient Information</span>
          </ava-expansion-panel-header>

          <ava-expansion-panel-content>
            <div class="tw-flex tw-flex-col !tw-gap-4">
              <p class="tw-text-base tw-font-extralight">
                Tell us a bit about the person you want to give a Membership to, and we'll make sure they aren't already
                a AAA Member and that they live in our territory.
              </p>
              <ava-gift-recipient-info-form
                formGroupName="giftInfo"
                [showGiftOption]="showGiftOption()"
                [showGiftMessage]="showGiftMessage"
                [memberStates]="memberStates"
                [showAccidentMedicalPlan]="showMedicalPlanGiftInfo"
                [showAddressAutocomplete]="isAddressAutoCompleteEnabledFlag"
                [accidentMedicalPlanPrice]="associateMedicalPrice"
                (accidentMedicalChanged)="handleUpdateRecostValidate()"
                (autoRenewChanged)="handleUpdateRecostValidate()"
              />
              <ng-container formGroupName="memberInfo">
                <ava-membership-associate-form
                  formGroupName="membershipAssociates"
                  [requiredBirthday]="true"
                  [showAccidentMedicalPlan]="showMedicalPlanGiftInfo"
                  [accidentMedicalPlanPrice]="associateMedicalPrice"
                  [formValues]="formValues?.memberInfo?.membershipAssociates || []"
                  (addAssociate)="addAssociate()"
                  (removeAssociate)="removeAssociate($event)"
                  (accidentMedicalChanged)="handleUpdateRecostValidate()"
                  class="ava-join-associate"
                />
              </ng-container>

              <ava-button
                [block]="true"
                [isLoading]="isLoadingRecostValidation || joinFormVm.memberInfo.status === 'PENDING'"
                label="Continue"
                (clicked)="goToPayment(formActiveStep)"
                id="join_gift_continue"
              />

              @if (showPrivacyPolicyAndTermAndCondition()) {
                <p class="tw-text-base tw-font-extralight">
                  <i>
                    By submitting your personal information, you agree to accept our
                    <ava-link target="_blank" [href]="termsAndConditionUrl()">terms and conditions</ava-link>
                    and
                    <ava-link target="_blank" [href]="privacyUrl()">privacy policy</ava-link>.
                  </i>
                </p>
              }
            </div>
          </ava-expansion-panel-content>
        </ava-expansion-panel>
      }

      <ava-expansion-panel panelId="memberInfo">
        <ava-expansion-panel-header>
          <span class="tw-font-mission">{{ memberInfoLabel$ | async }}</span>
        </ava-expansion-panel-header>

        <ava-expansion-panel-content>
          <div class="tw-flex tw-flex-col !tw-gap-4">
            <ava-member-info-form
              formGroupName="memberInfo"
              [showAccidentMedicalPlan]="showMedicalPlanCurrentClub && hideAddAssociate === false"
              [showAddressAutocomplete]="isAddressAutoCompleteEnabledFlag"
              [accidentMedicalPlanPrice]="(primaryMedicalPrice$ | async)!"
              [page]="page"
              [showPassword]="page === 'join' && showPassword()"
              [showCardFormat]="page === 'join' && showCardFormat()"
              [cardTypes]="page === 'join' ? cardTypes() : []"
              [showBirthday]="(showBirthday$ | async)!"
              [requiredBirthday]="page === 'join' && isRequireBirthday()"
              [showPhoneNumber]="(showPhoneNumber$ | async)!"
              [requiredPhone]="(showPhoneNumber$ | async)! && isRequirePhone()"
              [memberStates]="page === 'join' ? memberStates : allStates"
              (accidentMedicalChanged)="handleUpdateRecostValidate()"
              (dateChange)="doRecostValidation() ? handleUpdateRecostValidate() : null"
            />

            @if (page === 'join' && hideAddAssociate === false) {
              <ng-container formGroupName="memberInfo">
                <ava-membership-associate-form
                  formGroupName="membershipAssociates"
                  [showAccidentMedicalPlan]="showMedicalPlanCurrentClub"
                  [accidentMedicalPlanPrice]="associateMedicalPrice"
                  [formValues]="formValues?.memberInfo?.membershipAssociates || []"
                  [addAdditionalNotes]="
                    page === 'join' && clubId() === ClubApp.SouthJersey
                      ? getSouthJerseyAdditionalNotes()
                      : getDefaultAdditionalNotes()
                  "
                  (addAssociate)="addAssociate()"
                  (removeAssociate)="removeAssociate($event)"
                  (accidentMedicalChanged)="handleUpdateRecostValidate()"
                  class="ava-join-associate"
                  id="membershipAssociates"
                >
                  @if (clubId() === ClubApp.Colorado) {
                    <p class="tw-text-left tw-font-arial tw-text-base tw-font-extralight">
                      When you add another person in your household to your Membership, these Associate Members get the
                      same benefits as you. The first additional Basic member is FREE for the first year!
                    </p>
                  }
                </ava-membership-associate-form>
              </ng-container>
            }

            <ava-button
              [block]="true"
              [isLoading]="isLoadingRecostValidation || joinFormVm.memberInfo.status === 'PENDING'"
              [disabled]="joinFormVm.formGroup.disabled"
              label="Continue to Payment"
              (clicked)="goToPayment(formActiveStep)"
              id="join_member_info_continue"
            />

            @if (showPrivacyPolicyAndTermAndCondition()) {
              <p class="tw-text-left tw-font-arial tw-text-base tw-font-extralight">
                <i>
                  By submitting your personal information, you agree to accept our
                  <ava-link target="_blank" [href]="termsAndConditionUrl()">terms and conditions</ava-link>
                  and
                  <ava-link target="_blank" [href]="privacyUrl()">privacy policy</ava-link>.
                </i>
              </p>
            }
          </div>
        </ava-expansion-panel-content>
      </ava-expansion-panel>

      <ava-expansion-panel panelId="paymentInfo">
        <ava-expansion-panel-header>
          <span class="tw-font-mission">Payment</span>
        </ava-expansion-panel-header>

        <ava-expansion-panel-content>
          <div class="tw-flex tw-flex-col !tw-gap-4">
            <!-- Northway: auto renew enrolls in its own AXIS session after the paid join (2026-10-12); on the
                 test build only for now (northwayAutoRenewOpen, functions campana/AUTO-RENEW-REVIEW.md W5) -->
            <ava-payment-form
              #paymentFormComponent
              [disableAutoRenew]="isDisabledChangeAutoRenew || clubId() === ClubApp.Northampton || northwayBusy"
              [forceAutoRenewValue]="
                isNapamapProgramCode || (queryAutoRenew && showAutoRenew() && clubId() !== ClubApp.Northampton)
                  ? true
                  : null
              "
              [skipPaymentValidation]="
                checkIfSkipPaymentValidation({
                  isPaymentValidationDisableFlag: isPaymentValidationDisableFlag,
                  totalCost: totalCost,
                  payment: payment,
                })
              "
              [showAutoRenew]="showAutoRenew()"
              [showToggleAutoRenew]="isToggleAutoRenewEnabledFlag"
              [showMonthlyPayment]="showMonthlyPayment"
              [autoRenewTooltipText]="(autoRenewTooltipText$ | async)!"
              [showAutoRenewDescription]="isToggleAutoRenewEnabledFlag || clubId() === ClubApp.Colorado"
              [autoRenewLabelText]="clubId() === ClubApp.Colorado ? 'Enroll in Automatic Renewal' : undefined"
              [paymentType]="paymentType"
              [showRequireMessage]="!!(hasAutoRenewMembershipLevel$ | async)"
              (autoRenewChanged)="handleUpdateRecostValidate()"
              (monthlyChanged)="handleMonthlyBilling($event)"
              (payNow)="goToSummary(formActiveStep)"
              class="tw-flex tw-flex-col tw-gap-1"
            >
              <ng-container formGroupName="memberInfo">
                <ng-container formGroupName="membership">
                  @if (isEaglesMvpCardEnabledFlag) {
                    <ava-form-checkbox
                      (changed)="handleUpdateRecostValidate()"
                      formControlName="mvpCard"
                      formLabel="Eagles MVP card"
                    />
                  }

                  @if (
                    showApplyPromo(
                      isJoinPromoCodeDisabledFlag,
                      hideApplyPromo,
                      paymentFormComponent.paymentVm.formGroup.value.monthly
                    )
                  ) {
                    @let promoDescription = (promoDescription$ | async)!;
                    @let promoCodeWarningRequireAutoRenew = (promoCodeWarningRequireAutoRenew$ | async)!;

                    <ava-form-promocode
                      formControlName="promoCode"
                      [promoDescription]="promoDescription"
                      [warningMessage]="promoCodeWarningRequireAutoRenew"
                      [isLoading]="isLoadingRecostValidation || northwayBusy"
                      (applyPromoCode)="applyPromo()"
                    />
                  }
                </ng-container>
              </ng-container>

              <ava-billing-form
                formGroupName="billing"
                [states]="allStates"
                class="tw-mb-4 tw-flex tw-flex-col tw-gap-1"
              />
            </ava-payment-form>

            @if (clubId() !== ClubApp.Colorado) {
              <ava-button
                [block]="true"
                [disabled]="isLoadingRecostValidation || isLoadingPaymentForm"
                [isLoading]="isPaymentGenerating"
                label="Continue to Summary"
                (clicked)="goToSummary(formActiveStep)"
                id="join_payment_continue"
              />
            }
          </div>
        </ava-expansion-panel-content>
      </ava-expansion-panel>

      <ava-expansion-panel panelId="summary">
        <ava-expansion-panel-header>
          <span class="tw-font-mission">Summary</span>
        </ava-expansion-panel-header>

        <ava-expansion-panel-content>
          <div class="tw-flex tw-flex-col !tw-gap-4">
            <ava-offer-summary-cost
              [isLoading]="isLoadingRecostValidation"
              [offers]="offers"
              [totalCost]="totalCost"
              [isMonthlyBilling]="isMonthlyBilling"
              [allowZeroPrice]="allowZeroPrice"
            />
            <ava-terms-and-condition [termsAndConditions]="(termAndConditions$ | async)!" #termsAndConditionComponent />

            <ava-button-pay
              [isMonthlyBilling]="isMonthlyBilling"
              [disabled]="
                isLoadingPaymentForm ||
                !termsAndConditionComponent.acceptControl.value ||
                !(allowZeroPrice || (!allowZeroPrice && totalCost))
              "
              [price]="totalCost"
              [isLoading]="isLoadingRecostValidation || (isLoadingExecution$ | async)"
              (payNow)="
                pay({
                  formValues: formValues,
                  totalCost: totalCost,
                  offers: offers,
                  payment: payment,
                  selectedLevel: selectedLevel,
                  executionData: executionData,
                  page: page,
                  isPaymentValidationDisableFlag: isPaymentValidationDisableFlag,
                })
              "
            />
          </div>
        </ava-expansion-panel-content>
      </ava-expansion-panel>
    </ava-accordion>
  </form>

  <div
    class="tw-sticky tw-top-[var(--ava-join-summary-margin-top)] tw-w-full tw-max-w-[300px] tw-flex-col !tw-gap-2 tw-self-start md:tw-flex -md:tw-hidden"
  >
    <ava-join-sidebar-summary />

    <ava-offer-summary-cost
      [isLoading]="isLoadingRecostValidation"
      [offers]="offers"
      [totalCost]="totalCost"
      [isMonthlyBilling]="isMonthlyBilling"
      [allowZeroPrice]="allowZeroPrice"
    />
  </div>
</div>
